import transformString from "./transformString"

const publicEmailDomains: Array<string> = ['gmail', 'yahoo', 'hotmail', 'msn', 'wanadoo', 'aol', 'orange', 'comcast', 'live', 'outlook', 'googlemail', 'yopmail', 'rediffmail', 'ymail']

const validateDomain = (email: string) => {
    try {
        /** check if email has valid length */
        if (email.length < 10) {
            return false
        }
        /** Get the domain name */
        const subdomain = email.split('@')[1].split('.')[0]
        
        /** Check if domain names matches with our list */
        let result: boolean = !publicEmailDomains.includes(transformString(subdomain, '', ''))
        
        return result
    } catch (error) {
        console.log('Error in validating domain...')
        return false
    }

}

export default validateDomain